/**
 * Widget PostMessage Protocol (parent version)
 *
 * Utilities for parent to communicate with widget iframes.
 * Note: Widget-side utilities are in widget/shared/src/utils/widget-messaging.js
 */

/**
 * Messages that go from Parent to Widget
 */
export const PARENT_TO_WIDGET = {
  SET_SETTINGS: 'set-settings',
  SHOW: 'show',
  HIDE: 'hide',
  NAVIGATE_TO_PAGE: 'navigate-to-page',
  AUTO_FILL_TEST_DATA: 'auto-fill-test-data',
  RESET: 'reset',
};

/**
 * Messages that go from Widget to Parent
 */
export const WIDGET_TO_PARENT = {
  READY: 'widget-ready',
  FORM_SUBMITTED: 'form-submitted',
  FORM_RESET: 'form-reset',
  PAGE_CHANGED: 'page-changed',
  ERROR: 'widget-error',
};

/**
 * Send a message from parent to widget iframe
 * @param {HTMLIFrameElement} iframe - The widget iframe element
 * @param {string} message_type - Message type from PARENT_TO_WIDGET
 * @param {*} data - Optional data payload
 */
export function sendToWidget(iframe, message_type, data = null) {
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] sendToWidget called');
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] iframe:', iframe);
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] iframe.contentWindow:', iframe?.contentWindow);
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] message_type:', message_type);
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] data keys:', data ? Object.keys(data) : 'null');

  if (!iframe?.contentWindow) {
    // eslint-disable-next-line no-console
    console.warn('[Widget Messaging] Invalid iframe provided - no contentWindow');
    return;
  }

  const message = data !== null ? [message_type, data] : [message_type];
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] Sending message:', message);
  iframe.contentWindow.postMessage(message, '*');
  // eslint-disable-next-line no-console
  console.log('[Widget Messaging] Message sent successfully');
}

/**
 * Create a message handler for parent to listen to widget messages
 * @param {Object} handlers - Map of message types to handler functions
 * @returns {Function} Message handler function to attach to window
 */
export function createParentMessageHandler(handlers) {
  return function(event) {
    if (!event.data || !Array.isArray(event.data)) {
      return;
    }

    const [message_type, data] = event.data;

    const handler = handlers[message_type];
    if (handler) {
      handler(data);
    }
  };
}
